export function isObject(value: any): value is Record<PropertyKey, unknown> {
  return Object.prototype.toString.call(value) === '[object Object]';
}
